import ReactHtmlParser from 'react-html-parser'
import { DATE_FORMAT, convertTableDateFormat } from '../util/CommonUtils'

export const itemsResponseToItems = (items = []) => {
  return items.map((item) => itemResponseToItem(item))
}

export const itemResponseToItem = (item) => {
  const result = {
    barcodeNumber: item.barcode_number || '',
    classId: item.class_id || '',
    className: item.class_name || '',
    color: item.color || '',
    countryOfOrigin: item.country_of_origin,
    departmentId: item.department_id || '',
    subClassId: item.sub_class_id || '',
    subClassName: item.sub_class_name || '',
    departmentName: item.department_name || '',
    dpci: item.dpci || '',
    description: ReactHtmlParser(item.general_description || '')[0],
    imageUrl: item.image_url || '',
    launchDate: convertTableDateFormat(item.launch_date, DATE_FORMAT) || '',
    lifecycleState: item.lifecycle_state || '',
    manufacturerBrand: item.manufacturer_brand || '',
    manufacturerStyle: item.manufacturer_style || '',
    ownedBrand: item.is_owned_brand ? 'Yes' : 'No',
    onlineMerchandisingStatus: item.online_merchandise_status || '',
    isMerchantApprovedForPublishing:
      item.is_merchant_approved_for_publishing || false,
    isVirtualBundleChild:
      isVirtualBundleChild(item?.relationship?.details || [])?.type?.code ===
        'VBC' || false,
    intendedSellingChannels:
      (item.intended_selling_channels || []).join(',') || '',
    childTcins:
      relationshipFields(item?.relationship?.details || []) !== null
        ? relationshipFields(item?.relationship?.details || []).childDetails
        : '',
    childTcinSamplesReqQty: getReqChildSamplesQty(item) || Number(0),
    parentTcins:
      relationshipFields(item?.relationship?.details || []) !== null
        ? relationshipFields(
            item?.relationship?.details || []
          )?.parentIdentifiers?.tcins.join(', ') || ''
        : '',
    virtualBundleParentTcin:
      isVirtualBundleChild(item?.relationship?.details || [])?.type?.code ===
      'VBC'
        ? relationshipFields(item?.relationship?.details || []) !== null
          ? relationshipFields(
              item?.relationship?.details || []
            )?.parentIdentifiers?.tcins.join(', ') || ''
          : ''
        : '',
    isParent:
      relationshipFields(item?.relationship?.details || []) !== null
        ? relationshipFields(item?.relationship?.details || [])?.isParent
        : '',
    relationshipType:
      relationshipFields(item?.relationship?.details || []) !== null
        ? relationshipFields(item?.relationship?.details || []).type.name
        : '',
    size: item.size || '',
    tcin: item.tcin || '',
    vendorId: item.vendor_id || null,
    vendorName: item.vendor_name || '',
    brandId: item.brand_id || null,
    isOwnedBrand: item.is_owned_brand,
    kitType: item.relationship?.kit_type || '',
  }
  return result
}

export const getReqChildSamplesQty = (item) => {
  const childTcins =
    relationshipFields(item?.relationship?.details || []) !== null
      ? relationshipFields(item?.relationship?.details || []).childDetails
      : []
  const totalThresholdQuantity = childTcins?.reduce(
    (sum, child) => sum + (child.thresholdQuantity || 0),
    0
  )
  return totalThresholdQuantity
}
export function relationshipFields(relationships = []) {
  // Check for `is_parent` condition
  const parentIndex = relationships.findIndex(
    (item) => item.isParent || item.isParent === false
  )
  if (parentIndex >= 0) {
    return relationships[parentIndex]
  }

  // Check for `type.code === "VBP"` condition if `is_parent` is not found
  const vbpIndex = relationships.findIndex((item) => {
    return item?.type?.code === 'VBP'
  })

  if (vbpIndex >= 0) {
    relationships[vbpIndex].is_parent = true
    return relationships[vbpIndex]
  }

  // Return null if neither condition is met
  return null
}

export function isVirtualBundleChild(relationships = []) {
  if (
    relationships.findIndex(
      (item) =>
        item?.type?.code === 'VBC' ||
        item?.type?.name === 'Virtual Bundle Component'
    ) >= 0
  ) {
    return relationships[
      relationships.findIndex(
        (item) =>
          item?.type?.code === 'VBC' ||
          item?.type?.name === 'Virtual Bundle Component'
      )
    ]
  } else {
    return null
  }
}
